import React from "react";
import { Bot, ShoppingCart, Send } from "lucide-react";
import { featurePills, PURCHASE_URL, TELEGRAM_URL } from "../mock";

const Hero = () => {
  return (
    <section className="relative overflow-hidden pt-10 pb-20 px-4">
      <div className="pointer-events-none absolute inset-0 opacity-[0.05] bg-[radial-gradient(circle_at_center,#7dd3fc_1px,transparent_1px)] [background-size:22px_22px]" />

      {/* Logo card */}
      <div className="relative mx-auto max-w-[240px] mt-4">
        <div className="rounded-2xl border border-[#1e3a8a]/60 bg-[#0b1b3d]/40 p-6 shadow-[0_0_40px_rgba(59,130,246,0.15)] backdrop-blur-sm text-center">
          <div className="mx-auto h-24 w-24 rounded-full bg-white flex items-center justify-center shadow-lg">
            <div className="flex flex-col items-center">
              <div className="text-[9px] font-bold tracking-tight text-slate-800">Swift</div>
              <div className="text-[12px] font-black leading-none text-slate-900">Indicator</div>
              <div className="flex items-end gap-[2px] mt-1 h-6">
                <span className="w-1.5 h-2 bg-violet-500 rounded-sm" />
                <span className="w-1.5 h-3 bg-violet-500 rounded-sm" />
                <span className="w-1.5 h-4 bg-violet-600 rounded-sm" />
                <span className="w-1.5 h-5 bg-violet-700 rounded-sm" />
              </div>
            </div>
          </div>
          <p className="mt-4 text-[12px] font-semibold tracking-[0.25em] text-sky-400">
            SWIFT INDICATOR
          </p>
        </div>
      </div>

      <div className="relative mt-16 flex justify-center">
        <div className="inline-flex items-center gap-2 rounded-full border border-amber-500/40 bg-slate-900/60 px-5 py-2 backdrop-blur">
          <Bot className="h-4 w-4 text-amber-400" />
          <span className="text-[11px] font-bold tracking-[0.25em] text-amber-400">
            AI-POWERED TRADINGVIEW INDICATOR
          </span>
        </div>
      </div>

      <h1 className="relative mt-8 text-center font-black tracking-tight text-white">
        <span className="block text-6xl sm:text-7xl md:text-8xl leading-[0.95]">
          SWIFT-AI
        </span>
        <span className="block text-5xl sm:text-6xl md:text-7xl leading-[1] mt-2 bg-gradient-to-r from-sky-300 via-blue-400 to-indigo-400 bg-clip-text text-transparent">
          INDICATOR
        </span>
      </h1>

      <p className="relative mx-auto mt-8 max-w-xl text-center text-slate-300 text-base sm:text-lg leading-relaxed">
        A <span className="font-bold text-white">limited-signal</span> strategy
        built for <span className="font-bold text-white">big targets</span> —
        not scalping. Trade smarter on TradingView with precision AI logic.
      </p>

      <div className="relative mt-8 flex flex-col items-center gap-3">
        <a
          href={PURCHASE_URL}
          target="_blank"
          rel="noreferrer"
          className="group relative inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-sky-500 to-blue-600 px-10 py-4 font-bold tracking-wider text-white shadow-[0_0_40px_rgba(59,130,246,0.5)] transition-transform duration-300 hover:scale-[1.03] hover:shadow-[0_0_60px_rgba(59,130,246,0.75)]"
        >
          <ShoppingCart className="h-4 w-4" />
          <span className="text-sm">BUY NOW · LIFETIME ACCESS</span>
        </a>
        <p className="text-xs text-slate-400">
          One-time payment · Free future updates · 3 bonus scanners worth{" "}
          <span className="text-emerald-400 font-semibold">₹15,000</span>
        </p>
      </div>

      <p className="relative mx-auto mt-10 max-w-md text-center text-slate-400 text-sm">
        Optimize your trading strategy with the precision of our next-gen AI
        TradingView indicator.
      </p>

      <div className="relative mt-8 flex flex-wrap justify-center gap-3 px-2">
        {featurePills.map((p) => (
          <span
            key={p.label}
            className="inline-flex items-center gap-2 rounded-full border border-slate-700/70 bg-slate-900/50 px-4 py-2 text-xs sm:text-sm text-slate-200 backdrop-blur transition-colors duration-300 hover:border-sky-400/60"
          >
            <span
              className="h-2 w-2 rounded-full"
              style={{ backgroundColor: p.color, boxShadow: `0 0 10px ${p.color}` }}
            />
            {p.label}
          </span>
        ))}
      </div>

      <div className="relative mt-10 flex justify-center">
        <a
          href={TELEGRAM_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-sm font-semibold text-sky-400 hover:text-sky-300 transition-colors"
        >
          <Send className="h-4 w-4" />
          Join Free Telegram For Daily Updates
        </a>
      </div>
    </section>
  );
};

export default Hero;
